import React, { createContext, PropsWithChildren, useContext } from 'react';
import { useEditForm } from '../hooks/useEditForm';
import { IRouterProps } from 'pages/orderHistory';
import { useAnswerManager } from 'pages/forms/hooks/useAnswerManager';
import { AnswerContext } from 'pages/forms/context';

type Params = IRouterProps & {
  params?: Record<string, string | undefined>;
};

export const EditFormContext = createContext({} as ReturnType<typeof useEditForm>);

export const EditFormProvider = ({ children, params, router }: PropsWithChildren<Params>) => {
  const value = useEditForm({ params, router });
  const answersConfig = useAnswerManager();
  return (
    <AnswerContext.Provider value={answersConfig}>
      <EditFormContext.Provider value={value}>
        <value.Snackbar />
        {children}
      </EditFormContext.Provider>
    </AnswerContext.Provider>
  );
};

export const useEditFormContext = () => useContext(EditFormContext);
